<template>
  <div
    class="wl-design"
  >
    <div class="design-general">
      <div class="design-general__favicon">
        <div
          class="favicon-wrapper"
        >
          <template v-if="!favicon">
            <IconCustom
              name="icn24_image"
              color="#96A2AE"
              width="24"
              height="24"
            />
          </template>
          <v-img
            v-else
            width="100%"
            height="100%"
            contain
            :src="favicon"
          />
          <input
            ref="image"
            type="file"
            style="display: none"
            accept="image/*"
            @change="setImage"
          >
        </div>
        <div class="upload-actions">
          <div class="upload-actions__title">
            {{ $t('whitelabel.designTab.companyFavicon') }}
            <v-tooltip top>
              <template #activator="{ on }">
                <span
                  v-on="on"
                >
                  <IconCustom
                    color="#96A2AE"
                    name="icn16_info_circle"
                  />
                </span>
              </template>
              {{ $t('whitelabel.designTab.faviconHint') }}
            </v-tooltip>
          </div>
          <div class="upload-actions__wrapper">
            <div
              class="upload-actions__load"
              @click="$refs.image.click()"
            >
              {{ $t('whitelabel.designTab.loadLogo') }}
              <div />
            </div>
            <div
              class="upload-actions__delete"
              @click="updateFavicon(null)"
            >
              {{ $t('whitelabel.designTab.deleteLogo') }}
              <div />
            </div>
          </div>
          <helper-cropper
            ref="cropper"
            :aspect-ratio="50 / 50"
            :width="50"
            :height="50"
            @updateAvatar="updateFavicon"
          />
        </div>
      </div>
      <div class="design-general__selects">
        <div class="design-general__font">
          <v-autocomplete
            v-if="gogleFonts"
            v-model="font_family"
            :items="gogleFonts.items"
            :item-text="'family'"
            hide-details
            outlined
            :item-value="'family'"
            :label="$t('whitelabel.fontFamily')+ '*'"
          >
            <template
              slot="item"
              slot-scope="data"
            >
              <span :style="'font-family:'+ data.item.family">
                {{ data.item.family }}
              </span>
            </template>
          </v-autocomplete>
        </div>
        <div class="design-general__theme">
          <v-select
            v-model="defaultSelectedTheme"
            :items="optionsThemes"
            :label="$t('whitelabel.defaultTheme')"
            :item-text="'label'"
            hide-details
            outlined
            :item-value="'value'"
            error-count="0"
          />
        </div>
      </div>
    </div>
    <div class="design-themes">
      <WhiteLabelTheme
        ref="lightTheme"
        theme="light"
        :edit-form="editForm"
        :enable-theme="enableThemeObj"
        :font-family="font_family"
        :favicon="favicon"
        @saveThemes="saveThemes"
      />
      <WhiteLabelTheme
        ref="darkTheme"
        theme="dark"
        :edit-form="editForm"
        :enable-theme="enableThemeObj"
        :font-family="font_family"
        :favicon="favicon"
        @saveThemes="saveThemes"
      />
    </div>
  </div>
</template>

<script>

import {directive as onClickaway} from "vue-clickaway";
import WhiteLabelTheme from "@/views/WhiteLabel/partial/WhiteLabelTheme.vue";
import IconCustom from "@/components/helper/IconCustom.vue";
import HelperCropper from "@/components/helper/Cropper.vue";

export default {
  name: "WhiteLabelDesign",
  directives: {
    onClickaway
  },
  components: {
    HelperCropper,
    IconCustom,
    WhiteLabelTheme,
  },
  props: {
    editForm: {
      type: Object,
      default: null
    },
  },
  data() {
    return {
      enableThemeObj: {
        light: true,
        dark: false,
      },
      defaultSelectedTheme: "light",
      favicon: null,
      allowThemeSwitch: false,
      darkThemeAllowed: false,
      darkSettings: null,
      lightSettings: null,
      gogleFonts: null,
      font_family: 'Open Sans',
    };
  },
  computed: {
    optionsThemes() {
      return [
        ...(this.enableThemeObj['light'] ? [{label: "Light Theme", value: "light"}] : []),
        ...(this.enableThemeObj['dark'] ? [{label: "Dark Theme", value: "dark"}] : []),
      ]
    },
  },
  watch: {
    editForm(value) {
      if (value) {
        this.font_family = value.font_family;
      }
      if (value.design) {
        this.defaultSelectedTheme = value.design.default_theme;
        this.allowThemeSwitch = value.design.allow_theme_switch;
        this.darkThemeAllowed = value.design.dark_theme_allowed;
        this.enableThemeObj['dark'] = value.design.dark_theme_allowed;
        this.enableThemeObj['light'] = value.design.allow_theme_switch || !value.design.dark_theme_allowed;
        this.favicon = value.design.favicon;
        this.setColors(value.design);
      }
    },
    enableThemeObj: {
      deep: true,
      handler(val) {
        if (!val.light && !val.dark) {
          val['light'] = true;
        }
      }
    },
    optionsThemes: {
      handler(val) {
        if(val && val.length === 1) {
          this.defaultSelectedTheme = val[0].value
        }
      }
    },
  },
  created() {
    fetch("https://www.googleapis.com/webfonts/v1/webfonts?key=AIzaSyAqitbRJpOgzDoQ9GLAEmoyt1t-qmfoHWs")
        .then(response => response.json())
        .then(data => {
          this.gogleFonts = {}
          let fonts = data.items.filter(item => {
            return item.category === 'sans-serif';
          });
          this.gogleFonts.items = fonts;
          fonts.forEach(item => {
            this.fontLoader(item.family)
          })
        })
  },
  mounted() {
  },
  methods: {
    fontLoader(font) {

      let query = 'family=' + font.replace(" ", "+")
      var headID = document.getElementsByTagName('head')[0];
      var link = document.createElement('link');
      link.type = 'text/css';
      link.rel = 'stylesheet';

      headID.appendChild(link);

      link.href = 'https://fonts.googleapis.com/css?' + query;
    },
    saveThemes(form, theme) {
      if (theme === "dark") {
        this.darkSettings = form;
      }
      if (theme === "light") {
        this.lightSettings = form;
      }
    },
    save() {
      this.$refs.darkTheme.save();
      this.$refs.lightTheme.save();
      this.darkThemeAllowed = this.enableThemeObj.dark;
      this.allowThemeSwitch = this.enableThemeObj.light && this.enableThemeObj.dark;
      let form = {
        logo: '',
        font_family: this.font_family,
        primary_color: "#0059FF",
        primary_color_text: "#fff",
        secondary_color: "#96A2AE",
        secondary_color_text: "#ffffff00",
        background_color: "#ffffff00",
        link_color: "#ffffff00",
        design: {
          default_theme: this.defaultSelectedTheme,
          allow_theme_switch: this.allowThemeSwitch,
          dark_theme_allowed: this.darkThemeAllowed,
          favicon: this.favicon,
          ...this.darkSettings,
          ...this.lightSettings
        }
      }
      this.$emit('saveForm', form);
    },
    setImage(e) {
      if (!this.$refs.cropper.setImage(e)) {
        this.$refs.image.value = "";
      }
    },
    updateFavicon(icon) {
      this.favicon = icon;
    },
    setColors(design) {
      const root = document.querySelector(":root");
      const COLOR_NAMES = [
        "light_theme_primary_color",
        "light_theme_secondary_color",
        "light_theme_primary_text_color",
        "light_theme_surface_color",
        "light_theme_surface_background",
        "light_theme_main_background",
        "light_theme_surface_color_70",
        "light_theme_surface_color_30",
        "light_theme_surface_color_10",
        "light_theme_surface_color_03",
        "light_theme_surface_background_03",
        "light_theme_surface_background_10",
        "dark_theme_primary_color",
        "dark_theme_secondary_color",
        "dark_theme_primary_text_color",
        "dark_theme_surface_color",
        "dark_theme_surface_background",
        "dark_theme_main_background",
        "dark_theme_surface_color_70",
        "dark_theme_surface_color_30",
        "dark_theme_surface_color_10",
        "dark_theme_surface_color_03",
        "dark_theme_surface_background_03",
        "dark_theme_surface_background_10",
      ];
      const getCssVarName = (queryName) => `--${queryName.split("_").map(val => val === 'theme' ? 'preview-theme' : val).join("-")}`;
      COLOR_NAMES.forEach((name) => {
        if (design && design[name]) {
          root.style.setProperty(getCssVarName(name), design[name]);
        }
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.wl-design {
  display: flex;
  flex-direction: column;
  padding: 12px;
  gap: 24px;
}

.design-general {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  width: 100%;

  &__favicon {
    flex: 1;
  }

  &__selects {
    flex: 1;
    display: flex;
    gap: 8px;
  }

  &__font {
    flex: 3;
    min-width: 100px;
  }

  &__theme {
    flex: 2;
  }


}

.design-themes {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;

  .wl-theme {
    flex: 1;
  }
}
.design-general__favicon {
  display: flex;
  gap: 12px;

  .favicon-wrapper {
    width: 56px;
    height: 56px;
    padding: 10px;
    border-radius: 8px;
    border: 1px solid var(--light-theme-surface-color-10, rgba(49, 57, 44, 0.10));
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .upload-title {
      color: var(--primary-color, #0059FF);
      font-size: 15px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }

    .upload-details {
      color: var(--light-theme-surface-color-30, rgba(0, 0, 0, 0.30));
      font-size: 10px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }
  }

  .upload-actions {
    display: flex;
    flex-direction: column;
    gap: 4px;
    justify-content: center;
    align-items: flex-start;

    &__title {
      font-size: 15px;
      font-style: normal;
      height: 18px;
      font-weight: 600;
      line-height: 0;
      display: flex;
      align-items: center;
      gap: 8px;
    }

    &__wrapper {
      display: flex;
      gap: 12px;

      .upload-actions__load {
        cursor: pointer;
        color: var(--primary-color, #0059FF);
        font-size: 13px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
      }

      .upload-actions__delete {
        cursor: pointer;
        color: var(--light-theme-surface-color-70, rgba(49, 57, 44, 0.70));
        font-size: 13px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
      }
    }

  }
}
</style>
